import { useMemoizedFn } from '@/hooks';
import {
  // getHackConfig,
  // HackConfig,
  postReport,
  PostReportParams,
} from '@/services/report';
import { hashSHA256 } from '@/utils';
import {
  Breadcrumb,
  Button,
  Empty,
  EToastType,
  Input,
  Textarea,
  // ToastContainer,
  toast,
  Upload,
  UploadFile,
} from '@bfe/moly';
import { useFm, useNavigate, useScreenType } from '@web3/base-hooks';
import {
  APIBaseURL,
  getResultFromResponse,
  runAsyncSafe,
} from '@web3/base-utils';
import {
  useCurrentWallet,
  connectWalletModalStore,
  thirdPartyWallet,
} from '@web3fe/infra';
import classNames from 'classnames';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useAsyncFn, useCopyToClipboard } from 'react-use';
import { useConstent } from './constants';
import { scTrack, monitorLog } from '@web3/base-tracking';
import { Event, Page } from '@/config/track-config';
import styles from './index.module.scss';

export const Content = () => {
  const { navigateToPcPage } = useNavigate();
  const [, copyToClipboard] = useCopyToClipboard();
  const fm = useFm();
  const { isMobile } = useScreenType();
  const { formBase, formAdditional, formList } = useConstent();

  const items = [
    {
      key: '1',
      label: () => (
        <a
          className="no-underline text-inherit"
          onClick={() => {
            navigateToPcPage('/', '_self');
          }}
        >
          Home
        </a>
      ),
    },
    {
      key: '2',
      title: 'Submit Report',
    },
  ];

  // 暂时用不上，后面可能要用，先注释
  // const [config, setConfig] = useState<HackConfig>();
  // const getConfig = useCallback(() => {
  //   getHackConfig().then((res) => {
  //     console.log('getConfig====>', res);

  //     if (res?.success) {
  //       setConfig(res.result);
  //     }
  //   });
  // }, []);

  // useEffect(() => {
  //   getConfig();
  // }, []);

  // 上传文件
  const [imgList, setImgList] = useState<UploadFile[]>([]);
  const uploadFn = (file: Blob) => {
    const formData = new FormData();
    formData.append('uploadFile', file);
    return new Promise((resolve, reject) => {
      fetch(`${APIBaseURL}/spot/api/web3/content/hack/uploadImage`, {
        method: 'POST',
        body: formData,
      })
        .then(async (res) => {
          const data = await res.json();
          if (!data.success) {
            toast({
              iconType: EToastType.FAIL,
              title:
                data?.message ??
                'An error has occurred. Please try again later',
            });
          }
          resolve(data);
        })
        .catch((err) => {
          console.log(err.message);
          toast({
            iconType: EToastType.FAIL,
            title:
              err.message ?? 'An error has occurred. Please try again later',
          });
          reject(err);
        });
    });
  };
  const customRequest = useCallback(
    ({
      file,
      onSuccess,
      onError,
    }: {
      file;
      onProgress: (params: { percent: number }, file) => void;
      onSuccess: (file) => void;
      onError: (event: Error, response: Record<string, unknown>, file) => void;
    }) => {
      uploadFn(file)
        .then((res: any) => {
          if (res?.success) {
            onSuccess(res?.result);
          } else {
            onError(new Error(), res?.ret_msg, file);
          }
        })
        .catch((err) => {
          onError(new Error(), err, file);
        });

      return {
        abort() {
          // console.log('upload progress is aborted.');
        },
      };
    },
    []
  );

  const { evmAddress, getEvmSigner } = useCurrentWallet();

  const [submitInfo, setSubmitInfo] = useState<PostReportParams>({
    reporterAddress: evmAddress,
  } as PostReportParams);

  const setSubmitField = useMemoizedFn((key, value) => {
    setSubmitInfo((state) => ({
      ...state,
      [key]: value,
    }));
  });

  useEffect(() => {
    setSubmitField('reporterAddress', evmAddress);
  }, [evmAddress]);

  const resetInput = useMemoizedFn(() => {
    setSubmitInfo({
      reporterAddress: evmAddress,
    } as PostReportParams);
    setImgList([]);
    setTimeout(() => {
      location.reload();
    }, 3000);
  });

  const verifyFiledKey = useMemo(() => {
    // console.log('verifyFiledKey====>', submitInfo, imgList);
    let verifyFiled = false;
    formList?.forEach((formItem) => {
      if (formItem?.required && !submitInfo[formItem.fieldKey]) {
        verifyFiled = true;
      }
    });
    return verifyFiled;
  }, [submitInfo, formList]);

  const buttonDisabled = useMemo(
    () => evmAddress && verifyFiledKey,
    [verifyFiledKey, evmAddress]
  );
  // 提交
  const [handleSubmitState, handleSubmit] = useAsyncFn(
    useMemoizedFn(async () => {
      scTrack(Event.HackbountyUserClick, {
        page_name: Page.BountySubmitPage,
        button_name: 'Submit',
        ContactInfo: evmAddress,
      });

      if (imgList?.length) {
        const reportFile = [];
        imgList.forEach((item) => reportFile.push(item.response));
        submitInfo['reportFile'] = reportFile.join(',');
      }

      console.log('submitInfo===>', submitInfo);
      // 校验

      const queryString = serializeToQueryString(submitInfo);
      const msg = await hashSHA256(queryString);
      const signer = await getEvmSigner();
      const signature = await signer?.signMessage(msg);

      submitInfo.sign = signature;
      submitInfo.msg = msg;

      console.log('signed params', {
        submitInfo,
        queryString,
        msg,
        signature,
        evmAddress,
      });
      submitInfo['sign'] = signature;

      // 提交请求
      const [err] = await runAsyncSafe(
        getResultFromResponse(postReport(submitInfo))
      );

      if (err) {
        toast({
          iconType: EToastType.FAIL,
          title: err?.message,
        });
        monitorLog({
          t: 'submit_report_failed',
          ext: {
            ...submitInfo,
            queryString,
            walletRnid: thirdPartyWallet.activeWalletHub?.id ?? '',
          },
          err,
        });
        return;
      } else {
        toast({
          iconType: EToastType.SUCCESS,
          title: 'Submitted Successfully!',
        });
        resetInput();
      }
    })
  );

  return (
    <div className={classNames(styles['report'])}>
      <div className={classNames(styles['top'])}>
        <Breadcrumb
          items={items}
          className={classNames([styles['main'], isMobile && 'px-4'])}
        />
      </div>
      <div className={classNames(styles['main'], 'mt-8')}>
        {isMobile ? (
          <>
            <Empty
              title={
                <h2 className="text-2xl">
                  {fm('submitBountyReportActionEndpoint')}
                </h2>
              }
              subTitle={
                <p className="text-xs text-gray-t3">
                  {fm('traceFundsGuidelinesAndConfirmation')}
                </p>
              }
            />
            <div className="px-4 mt-10 mb-20">
              <p
                className="text-xs text-gray-t3 text-center"
                dangerouslySetInnerHTML={{ __html: fm('submitReportOpenLink') }}
              ></p>
              <Button
                variant={'primary'}
                className="w-full mt-4"
                onClick={() => {
                  copyToClipboard(location.href);
                  toast({
                    iconType: EToastType.SUCCESS,
                    title: 'copied',
                  });
                }}
              >
                Copy URL
              </Button>
            </div>
          </>
        ) : (
          <>
            <h1 className="text-2xl font-semibold">
              {fm('submitBountyReportActionEndpoint')}
            </h1>
            <p className="mt-4 text-sm text-gray-t3">
              {fm('traceFundsGuidelinesAndConfirmation')}
            </p>
            <div
              className={classNames('main justify-center', styles['form-wrap'])}
            >
              <h2
                className="text-sm text-white font-medium pb-3"
                style={{
                  borderBottom:
                    '1px solid var(--Trans_Hover, rgba(192, 210, 231, 0.12))',
                }}
              >
                {fm('basicInfo')}
              </h2>

              {/* 第1行 */}
              <div className="flex flex-wrap gap-x-18 gap-y-6 mt-6">
                {formBase?.map((item, index) => (
                  <div
                    className={classNames([
                      styles['field'],
                      item.long && styles['long'],
                    ])}
                    key={index}
                  >
                    <span
                      className={classNames([
                        styles['label'],
                        item.required && styles['required'],
                      ])}
                    >
                      {item.label}
                    </span>
                    {item.type === 'input' ? (
                      <Input
                        size="small"
                        className="mt-1"
                        type={item.inputType ?? 'text'}
                        value={submitInfo[item.fieldKey] || ''}
                        min={0}
                        maxLength={item.maxLength ?? 128}
                        placeholder={item.placeholder}
                        onChange={(evt) => {
                          let val = evt?.target?.value;
                          if (item.inputType === 'number' && val < 0) {
                            val = 0;
                          }
                          setSubmitField(item.fieldKey, val);
                        }}
                        disabled={item.disabled}
                        allowClear={!item.disabled ? true : false}
                      />
                    ) : null}
                    {item.type === 'textarea' ? (
                      <Textarea
                        label=""
                        className="mt-2 text-xs"
                        rows={item.rows}
                        placeholder={item.placeholder}
                        value={submitInfo[item.fieldKey] || ''}
                        maxLength={item.maxLength}
                        onChange={(evt) =>
                          setSubmitField(item.fieldKey, evt?.target?.value)
                        }
                      />
                    ) : null}
                  </div>
                ))}
              </div>

              <h2
                className="text-sm text-white font-medium pb-3 mt-12 mb-6"
                style={{
                  borderBottom:
                    '1px solid var(--Trans_Hover, rgba(192, 210, 231, 0.12))',
                }}
              >
                {fm('additionalInfo')}
              </h2>
              <div className="flex flex-wrap gap-x-18 gap-y-6 mt-6">
                {formAdditional?.map((item, index) => (
                  <div
                    className={classNames([
                      styles['field'],
                      item.long && styles['long'],
                    ])}
                    key={index}
                  >
                    <span
                      className={classNames([
                        styles['label'],
                        item.required && styles['required'],
                      ])}
                    >
                      {item.label}
                    </span>
                    {item.type === 'textarea' ? (
                      <Textarea
                        className="mt-2 text-xs"
                        label=""
                        placeholder={item.placeholder}
                        value={submitInfo[item.fieldKey] || ''}
                        maxLength={item.maxLength}
                        rows={item.rows}
                        onChange={(evt) =>
                          setSubmitField(item.fieldKey, evt?.target?.value)
                        }
                      />
                    ) : null}
                    {item.type === 'upload' ? (
                      <>
                        <p className="mt-2"></p>
                        <Upload
                          uploadText=""
                          // action={`${ApplicationGlobalConfig.baseURL}/spot/api/nft/dex/lookingForCollaboration/uploadFile`}
                          maxSize={10}
                          maxCount={5}
                          value={imgList}
                          accept="image/png,image/jpeg,image/jpg"
                          onChange={(file, list) => {
                            setImgList(list);
                          }}
                          onError={(err) => {
                            console.log(err);
                          }}
                          customRequest={customRequest as any} // eslint-disable-line
                        />
                      </>
                    ) : null}
                  </div>
                ))}
              </div>
              {/* {evmAddress ? ( */}
              <Button
                className="mt-6 mb-20 px-14"
                variant={'primary'}
                disabled={buttonDisabled}
                loading={handleSubmitState.loading}
                onClick={() => {
                  evmAddress
                    ? handleSubmit()
                    : connectWalletModalStore.show({
                        activeTab: 'bybit',
                        bybitExtVersion: '',
                      });
                }}
              >
                {evmAddress ? 'Submit Report' : 'Connect Wallet'}
              </Button>
              {/* ) : (
                <Web3ConnectButton className="mt-12 px-14"></Web3ConnectButton>
              )} */}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
/** 签名字段，按文档里指定的顺序：https://uponly.larksuite.com/wiki/JXwXwZ5DsipYjRkqdvbu4Axxscg */
const serializeToQueryString = (obj: PostReportParams) => {
  return [
    `entityName=${obj.entityName ?? ''}`,
    `entityUserAddress=${obj.entityUserAddress ?? ''}`,
    `fundTokenName=${obj.fundTokenName ?? ''}`,
    `relatedTxHash=${obj.relatedTxHash ?? ''}`,
    `reporterAddress=${obj.reporterAddress ?? ''}`,
  ].join('&');
};
